import '@vendor/stage0/0_jquery';
window.$ = require("@vendor/stage0/0_jquery.js");
window.jQuery = require("@vendor/stage0/0_jquery.js");
